export const motion = {
  duration: { fast: 0.2, normal: 0.45, reveal: 0.75 },
  reveal: { y: 32, stagger: 0.08, start: "top 88%" },
  ease: "power3.out",
} as const;
